import React from "react";
import { IButtonGroup, IColumn } from "../../../interfaces/base/ITable";
import { Icon, TooltipHost } from "@fluentui/react";
import ThemeBase from "../../../utils/Theme/themeBase";
import { TableComponent } from "../../../components/Table/TableComponent";
import { HeadingBar } from "../../../components/Generic/HeadingBar";
import { UseUbicacion } from "./UseUbicacion";
import { useBoolean } from "@fluentui/react-hooks";
import { PanelUbicacionCrear } from "./crear/PanelUbicacionCrear";
import { PanelUbicacionEditar } from "./editar/PanelUbicacionEditar";
import { PanelUbicacionEliminar } from "./eliminar/PanelUbicacionEliminar";
import { IUbicacionDTO } from "../../../interfaces/ubicacion/IUbicacion";
import PanelAsignarEmpresa from "./PanelAsignarEmpresa";
import { IconHelper } from "../../../utils/Helper/iconHelper";
import { ConfigHelper } from "../../../utils/Helper/configHelper";
import { useNavigate } from "react-router-dom";
import { useMakeStyle } from "../../../functions/BaseStyle";
import { ColorHelper } from "../../../utils/Helper/colorHelper";

const iconDetalleStyle: React.CSSProperties | undefined = {
  color: "#0078d4",
};

const Ubicacion = () => {
  const style = useMakeStyle();
  const [isOpenCrear, { setTrue: openPanelCrear, setFalse: closePanelCrear }] =
    useBoolean(false);
  const [
    isOpenAsignar,
    { setTrue: openPanelAsignar, setFalse: closePanelAsignar },
  ] = useBoolean(false);
  const [
    isOpenEditar,
    { setTrue: openPanelEditar, setFalse: closePanelEditar },
  ] = useBoolean(false);
  const [
    isOpenEliminar,
    { setTrue: openPanelEliminar, setFalse: closePanelEliminar },
  ] = useBoolean(false);

  const navigate = useNavigate();
  const {
    items,
    filter,
    setFilter,
    loading,
    pagination,
    handleResetUpdate,
    onChangeSearch,
    setDataEdit,
    dataEdit,
    setDataAsignar,
    dataAsignar,
  } = UseUbicacion();

  const buttonLeft: IButtonGroup[] = [
    {
      onClick: () => {
        openPanelCrear();
      },
      text: "Nuevo",
    },
    {
      onClick: () => {
        handleResetUpdate();
      },
      text: "Actualizar",
    },
  ];

  const buttonRight: IButtonGroup[] = [
    {
      onClick: () => {
        // openPanelFiltrar()
      },
      text: "Filtrar",
      background: "#0078d4",
      color: "whitesmoke",
    },
  ];

  function renderOpciones(item: IUbicacionDTO) {
    return (
      <>
        <TooltipHost content={`Editar`}>
          <Icon
            iconName="Edit"
            className={ThemeBase.classNamesIcon.iconFont}
            // style={iconDetalleStyle}
            onClick={() => {
              setDataEdit(item);
              openPanelEditar();
            }}
            color="green"
          />
        </TooltipHost>

        {/* <TooltipHost content={`Elminar`}>
          <Icon
            iconName="bus"
            className={ThemeBase.classNamesIcon.cyanBlue10}
            // style={iconDetalleStyle}
            onClick={() => {
              setDataAsignar(item);

              openPanelAsignar();
            }}
          />
        </TooltipHost> */}
        <TooltipHost content={`Detalle`}>
          <Icon
            iconName={IconHelper.ICON_DETAIL.iconProps?.iconName}
            style={{ cursor: "pointer" }}
            className={ThemeBase.classes.iconFont}
            onClick={() => {
              setDataAsignar(item);
              //   openPanelAsignar();
              navigate(
                `${ConfigHelper.urlBase()}/configuraciones/lugar/${
                  item.lugarMovilizacionId
                }`,
                { state: { data: item } }
              );
            }}
          />
        </TooltipHost>
        <TooltipHost content={`Elminar`}>
          <Icon
            iconName="Delete"
            className={ThemeBase.classNamesIcon.iconFont}
            // style={iconDetalleStyle}
            onClick={() => {
              setDataEdit(item);
              openPanelEliminar();
            }}
          />
        </TooltipHost>
      </>
    );
  }

  const _columns: IColumn[] = [
    {
      key: "numeracion",
      name: "N°",
      fieldName: "numeracion",
      minWidth: 30,
      maxWidth: 50,
      onRender: (item, index) => <>{(index ?? 0) + 1}</>,
    },
    {
      key: "nombre",
      name: "Nombre",
      fieldName: "nombre",
      minWidth: 100,
      maxWidth: 350,
    },
    {
      key: "codigo",
      name: "Código",
      fieldName: "codigo",
      minWidth: 100,
      maxWidth: 100,
    },
    {
      key: "requiereTransporte",
      name: "Transporte",
      fieldName: "requiereTransporte",
      minWidth: 60,
      maxWidth: 60,
      onRender: (item: IUbicacionDTO) => 
        <TooltipHost content={`${item.requiereTransporte ? "Requiere" : "No requiere"} Bus`}>
          <Icon
            iconName="BusSolid"
            style={{ cursor: "pointer", color:  item.requiereTransporte ? ColorHelper.SUCCESS : ColorHelper.DANGER }}
            className={`${ThemeBase.classes.iconFont}`}
          />
        </TooltipHost>
    },
    {
      key: "requiereVueloComercial",
      name: "Vuelo C.",
      fieldName: "requiereVueloComercial",
      minWidth: 60,
      maxWidth: 60,
      onRender: (item: IUbicacionDTO) => 
        <TooltipHost content={`${item.requiereVueloComercial ? "Requiere" : "No requiere"} Vuelo Comercial`}>
          <Icon
            iconName="AirPlaneSolid"
            style={{ cursor: "pointer", color: item.requiereVueloComercial ? ColorHelper.SUCCESS : ColorHelper.DANGER }}
            className={`${ThemeBase.classes.iconFont}`}
          />
        </TooltipHost>
    },
    {
      key: "usuarioRegistra",
      name: "Registrado por",
      fieldName: "usuarioRegistra",
      minWidth: 100,
      maxWidth: 250,
    },
    {
      key: "estado",
      name: "Estado",
      fieldName: "estado",
      minWidth: 80,
      maxWidth: 150,
    },
    {
      key: "opciones",
      name: "Opciones",
      minWidth: 50,
      maxWidth: 100,
      fieldName: "opciones",
      onRender: (item: any) => renderOpciones(item),
    },
  ];

  return (
    <div className={style.body}>
      <HeadingBar
        title="Lugar Movilizaciones"
        subTitle={`Gestión de Ubicaciones`}
        searchShow={false}
      />

      <TableComponent
        data={items}
        leftButtons={buttonLeft}
        // rightButton={buttonRight}
        column={_columns}
        paginacion={pagination}
        isLoading={loading}
        isSearch={true}
        onChangeSearch={onChangeSearch}
      />

      <PanelUbicacionCrear
        isOpen={isOpenCrear}
        onDismiss={closePanelCrear}
        reload={handleResetUpdate}
      />
      <PanelAsignarEmpresa
        isOpen={isOpenAsignar}
        onDismiss={closePanelAsignar}
        dataMov={dataAsignar?.lugarMovilizacionId}
      />

      <PanelUbicacionEditar
        isOpen={isOpenEditar}
        onDismiss={closePanelEditar}
        reload={handleResetUpdate}
        ubicacionData={dataEdit}
      />

      <PanelUbicacionEliminar
        isOpen={isOpenEliminar}
        onDismiss={closePanelEliminar}
        reload={handleResetUpdate}
        ubicacionData={dataEdit}
      />
    </div>
  );
};

export { Ubicacion };
